import React from "react";
import AccessPDFPod from '@/components/AccessPDFPod';
import AccessVideoPod from '@/components/AccessVideoPod';
import AccessTextPod from '@/components/AccessTextPod';

const ComponentNotFound = ({ name }) => <span>Component {name} was requested but not registered.</span>;
const components = {};

const PodRenderer = ({ podule, ...props }) => {
  switch (podule.renderer) {
    case 'component':
      const Component = components[podule.itself];
      return Component ? <Component podule={podule} {...props} /> : <ComponentNotFound name={podule.itself} />;
    case 'pdf':
      return <AccessPDFPod podule={podule} {...props} />;
    case 'video':
      return <AccessVideoPod podule={podule} {...props} />;
    case 'md':
      return <AccessTextPod podule={podule} {...props} />;
    default:
      return <>this is a pod</>;
  }
};

export default PodRenderer;